import React from 'react';
import Parent from '../parent';
import { withTranslation } from 'react-i18next';
import BackNextBar from './backNextBar';
import {BllinkLogger} from '../utils/bllink_loggers';
import UnpaidMonths from './unPaidMonths';
import MonthsRelatedLogic from './monthsRelatedLogic';
import $ from 'jquery';
import { constants } from '../constants/constants';
import AllPaid from './allPaid';
import CacheData from '../utils/cacheData';
import MonthRelatedSelectBox from "./monthRelatedSelectBox";
import AddFastPayment from './fastOneTime/addFastPayment';
import {Datepicker} from '../Datepicker';
import DatepickerNew from '../DatepickerPortal';

export class OnGoingPaymentSection extends Parent {

    constructor(props) {
        super(props);
        BllinkLogger.info('constructor OnGoingPaymentSection ', props)

        this.typOfPayment = constants.cache.keys.payments.onGoingPayments;
        this.state = this.newState(props);
        this.state.isAdmin = false;
    }

    async componentDidMount() {
        const isManager = await this.isLoggedIn();
        this.isManager = isManager;
        const isAdmin = await this.isAdmin();
        const isDev = await this.isDeveloper();
        this.setState({
            isAdmin,
            isManager,
            isDev,
        });

        this.setState(this.newState(this.props));
    }

    componentDidUpdate(prevProps) {
        if (prevProps !== this.props) {
            BllinkLogger.info('componentDidUpdate OnGoingPaymentSection', this.props)
            this.setState(this.newState(this.props));
        }
    }

    onGoingInputChanged = e => {
        /*
            discussion with omri 1/10/20 -
            Each time a use selects a checkbox,
            it should auto select all the months from start to
            the selected month.
            The logic behind it is that the tenant has to pay
            for consecutive months only! can't have a month missing

        */
        const itemNumberSelected = parseInt($(e.target).attr('item-number'));
        let selectedMonths = this.calcAndCacheMonth(itemNumberSelected);
        this.showHideRewards(selectedMonths);
        // recalculating after manipulating dom
        this.calcAndCacheMonth(itemNumberSelected);

        const newStatePayload = this.newState({
            buildingID: this.state.buildingID,
            apartmentNumber: this.state.apartmentNumber
        })

        this.cacheSelectedInstallmentsIfNeeded(newStatePayload.maxInstallments);

        // to rerender the page
        this.setState(newStatePayload);

    }

    calcAndCacheMonth(itemNumberSelected) {
        const selectedMonths = MonthsRelatedLogic.handleOngoingMonthsSelected(
            this.state.onGoingMonths,
            itemNumberSelected
        );

        // cache current selected months
        MonthsRelatedLogic.cacheCurrentSelectedMonths(
            selectedMonths,
            this.typOfPayment,
            this.state.buildingID,
            this.state.apartmentNumber
        )

        return selectedMonths;
    }

    showHideRewards(selectedMonths) {
        // rewards should hide if less than 6 months were selected

        BllinkLogger.info(`showHideRewards `, selectedMonths);
        const payments = this.state.payments;
        const onGoingRewards = (payments || {}).rewards;

        if (onGoingRewards) {
            let minMonths = onGoingRewards[0].minMonths;
            let numberOfMonthsSelected = selectedMonths.filter((obj) => obj.selected).length;
            if (numberOfMonthsSelected < minMonths) {
                this.hideReward();
            } else {
                this.showReward()
            }
        }
    }



    cacheSelectedInstallmentsIfNeeded(maxInstallments) {
        // cache selected installments if they are smaller than the max installments allowed

        // const cachePayload = {key: this.typOfPayment};
        //https://app.asana.com/0/1198916940064391/1198957409540076 -
        // // ongoing payment page - number of payments should always suggest the user with max installment
        CacheData.cache('installmentsChoices',
            {selected: maxInstallments},
            {key: this.typOfPayment}
        )
    }

    getFuturePaymentDate = (months) => {
        const currentDate = this.timeUtils.getTimeNow();
        const isFuturePayments = this.timeUtils.isSmallerEqual(currentDate, {year: months[0]?.year, month: months[0]?.month});
        if (!isFuturePayments) return null;
        const chargeDate = CacheData.fetchCache('onGoingChargeDate', {buildingID: this.props.buildingID, apartmentNumber: this.props.apartmentNumber});
        let endDate = this.calculateEndDate(months); // re calculate either way to make sure it is correct due to a bug

        if (chargeDate){
            const same = endDate.getTime() === new Date(chargeDate.end).getTime();
            if (!same){
                console.log(`endDate != chargeDate.endDate overwriting the cache value to represent the new end date`);
                chargeDate.end = endDate;
            }
            return chargeDate;
        }

        // default should be 1st of first open month (with some conditions)
        // https://app.asana.com/0/1201972127603759/1201858763387375/f
        let defaultFutureChargeDate;
        const isNextOpenMonthIsCurrentMonth = parseInt(months[0].month) === currentDate.month;
        if (isNextOpenMonthIsCurrentMonth) {
            defaultFutureChargeDate = this.timeUtils.getTimeZoneOffset(new Date(currentDate.year, currentDate.month - 1, currentDate.day));
        } else {
            // JS Date smart enough to work with negative values
            const futureMonth = this.props.buildingData.assignedToNextMonth ? parseInt(months[0].month) - 2 : parseInt(months[0].month) - 1;
            defaultFutureChargeDate = this.timeUtils.getTimeZoneOffset(new Date(parseInt(months[0].year), futureMonth, 1));
        }

        const futureChargeDate = {
            default: defaultFutureChargeDate,
            start: this.timeUtils.getTimeZoneOffset(new Date(currentDate.year, currentDate.month - 1, 1)),
            end: endDate
        }
        CacheData.cache('onGoingChargeDate', futureChargeDate, {buildingID: this.props.buildingID, apartmentNumber: this.props.apartmentNumber});

        return futureChargeDate;
    }

    // https://app.asana.com/0/1202598412169841/1202559415977697
    // [BUG] future payment for same apartment
    // when a manager charges an apartment and then tries to charge it again,
    // the future datepicker is limited by the last selected date.
    calculateEndDate = (months) => {
        let endDate = this.timeUtils.getTimeZoneOffset(new Date(parseInt(months[0].year), parseInt(months[0].month), 0));
        if (this.props.buildingData.assignedToNextMonth) {
            // https://app.asana.com/0/1201421792207582/1201547769585958
            // "consider assigned to next month - change in the datepicker logic "
            const monthBefore = this.timeUtils.getPreviousMonth({
                month: parseInt(months[0].month),
                year: parseInt(months[0].year),
                day: 1
            });
            endDate = this.timeUtils.getTimeZoneOffset(new Date(monthBefore.year, monthBefore.month, 0));
        }
        // todo add 2 months to end date https://bllink.atlassian.net/browse/SSB-305
        endDate.setMonth(endDate.getMonth()+2);
        return endDate
    }


    newState(props) {
        const payments = props.payments || this.state.payments || {};
        const onGoingMonths = payments.paymentsSortedArray || [];
        const rewards = payments.rewards || [];

        // Check if apartment has future payments
        // hiding in case it's rapyd since rapyd still doesn't support future payments
        const shouldHideFutureCharge = props.buildingData?.currency?.toLowerCase() !== constants.defaultCurrency;
        let futureChargeDate = shouldHideFutureCharge ? false : this.getFuturePaymentDate(onGoingMonths);

        const onGoingMonthsFinal = MonthsRelatedLogic.fetchSelectedMonthsFromCache(
            onGoingMonths,
            this.typOfPayment,
            props.buildingID,
            props.apartmentNumber,
            rewards
        );

        const totalAmount = MonthsRelatedLogic.calcTotalAmountSelected(onGoingMonthsFinal);
        const totalAmountCurrency = onGoingMonthsFinal[0]?.total.currency;
        let maxByMonths = MonthsRelatedLogic.calcMaxOnGoingInstallmentsAllowed(onGoingMonthsFinal);
        const totalReward = MonthsRelatedLogic.calcRewardAmount(onGoingMonthsFinal);
        // https://app.asana.com/0/1196545425570329/1199873953427556
        // monthly payment - when management company login. need to add 12 payments even if less month are selected
        const maxInstallments = this.isManager ? Math.max(constants.FINAL_MONTH_IN_YEAR, maxByMonths) : maxByMonths;

        return {
            currency: totalAmountCurrency,
            onGoingMonths: onGoingMonthsFinal,
            totalAmount: totalAmount,
            maxInstallments: maxInstallments,
            defaultInstallments: maxByMonths,
            currentInstallments: maxByMonths,
            payments: payments,
            buildingID: props.buildingID,
            apartmentNumber: props.apartmentNumber,
            totalReward: totalReward,
            ...(futureChargeDate && {futureChargeDate})
        }
    }

    changeChargeDate = selectedDate => {
        console.log(selectedDate)
        if (!selectedDate) return;
        this.setState({
            futureChargeDate: {
                ...this.state.futureChargeDate,
                selected: this.timeUtils.getTimeZoneOffset(selectedDate)
            }
        }, () => {
            CacheData.cache('onGoingChargeDate', this.state.futureChargeDate, {buildingID: this.props.buildingID, apartmentNumber: this.props.apartmentNumber});
        });
    }

    renderMonths() {
        const {t} = this.props;
        this.setBodyClasses(constants.backgroundOptions.ongoingSelect);
        const onGoingMonths = this.state.onGoingMonths;
        const payments = this.state.payments;
        const onGoingRewards = (payments || {}).rewards;
        BllinkLogger.info(`onGoingMonths are`, onGoingMonths);

        const ltr = document.body.classList.contains('leftToRight');

        return (
            <div>
                <div id="on-going-months" className="payment-box">
                    <h4 className="pt-4 pb-3">{t('payments.on_going_title')}</h4>
                    <UnpaidMonths
                        months={onGoingMonths}
                        rewards={onGoingRewards}
                        onChangeFunc={this.onGoingInputChanged}
                    />
                </div>
                <MonthRelatedSelectBox
                    months={onGoingMonths}
                    currency={this.state.currency}
                    maxNumberOfInstallments={this.state.maxInstallments}
                    total={this.state.totalAmount}
                    name={this.typOfPayment}
                    totalReward={this.state.totalReward}
                    // https://app.asana.com/0/1196545425570329/1198921803890861 for on going select the max by default
                    defaultInstallments={this.state.defaultInstallments}
                    currentInstallments={this.state.currentInstallments}
                    isViewedAsManager={this.props.isViewedAsManager}
                    buildingID={this.state.buildingID}
                    apartmentNumber={this.state.apartmentNumber}
                    shouldHideCreditCardOption={this.props.shouldHideCreditCardOption}
                    isOnGoing={true}
                />
                {this.state.futureChargeDate && (
                    <div className={'row mb-4 installmentBox'}>
                        <div className={'col-md-7'} />
                        <div className={'col-md-5'}>
                            <div className={'row align-items-center'}>
                                <div className={'col-md-7 col-7 label'}>
                                    {t('payments.future_payment_date')}:
                                </div>
                                <div className={'col-md-5 col-5 date-column'}>
                                    <DatepickerNew
                                        minDate={new Date(this.state.futureChargeDate.start)}
                                        maxDate={new Date(this.state.futureChargeDate.end)}
                                        date={this.state.futureChargeDate.selected ? new Date(this.state.futureChargeDate.selected) : new Date(this.state.futureChargeDate.default)}
                                        placeholder={'dd/mm/yyyy'}
                                        onChange={this.changeChargeDate}
                                        ltr={ltr}
                                        id='date'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        )
    }

    render() {
        let monthHtml;
        BllinkLogger.info('render OnGoingPaymentSection ', this.state);
        const onGoingMonths = this.state.onGoingMonths;

        if (onGoingMonths.length === 0) {
            monthHtml = <AllPaid/>;
        } else {
            monthHtml = this.renderMonths();
        }

        return (
            <div className="col-md-12">
                <div className="js-select-payment-form">
                    {monthHtml}
                    {/* requested by rayee via email "if there is an open one time payment for the apartment, lets disable the fast one time from the on-going page"
*/}
                    {this.state.isManager && !this.props.hasOpenOneTimePayment && (
                        <AddFastPayment
                            buildingID={this.props.buildingID}
                            apartmentNumber={this.props.apartmentNumber}
                        />
                    )}
                    {/* todo should be in main selectPayments.js*/}
                    <BackNextBar
                        buildingID={this.props.buildingID}
                        apartmentNumber={this.props.apartmentNumber}
                        currentTab={constants.pages.onGoingTab}
                        paymentsStats={this.props.paymentsStats}
                        onNextBackChange={this.props.onChangeNextBack}
                        isViewedAsManager={this.props.isViewedAsManager}
                        shouldHideCreditCardOption={this.props.shouldHideCreditCardOption}
                    />
                </div>
            </div>
        )
    }
}

export default withTranslation()(OnGoingPaymentSection);
